/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetDictionaryTypeDto } from './GetDictionaryTypeDto';
import {
    GetDictionaryTypeDtoFromJSON,
    GetDictionaryTypeDtoFromJSONTyped,
    GetDictionaryTypeDtoToJSON,
} from './GetDictionaryTypeDto';

/**
 * 
 * @export
 * @interface GetDictionaryDto
 */
export interface GetDictionaryDto {
    /**
     * 
     * @type {string}
     * @memberof GetDictionaryDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GetDictionaryDto
     */
    systemNumber: number;
    /**
     * 
     * @type {string}
     * @memberof GetDictionaryDto
     */
    shortname: string;
    /**
     * 
     * @type {string}
     * @memberof GetDictionaryDto
     */
    value: string;
    /**
     * 
     * @type {string}
     * @memberof GetDictionaryDto
     */
    valueEn: string;
    /**
     * 
     * @type {string}
     * @memberof GetDictionaryDto
     */
    dictionaryTypeId: string;
    /**
     * 
     * @type {GetDictionaryTypeDto}
     * @memberof GetDictionaryDto
     */
    dictionaryType: GetDictionaryTypeDto;
    /**
     * 
     * @type {string}
     * @memberof GetDictionaryDto
     */
    parentId: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetDictionaryDto
     */
    active: boolean;
}

/**
 * Check if a given object implements the GetDictionaryDto interface.
 */
export function instanceOfGetDictionaryDto(value: object): value is GetDictionaryDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('systemNumber' in value) || value['systemNumber'] === undefined) return false;
    if (!('shortname' in value) || value['shortname'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('valueEn' in value) || value['valueEn'] === undefined) return false;
    if (!('dictionaryTypeId' in value) || value['dictionaryTypeId'] === undefined) return false;
    if (!('dictionaryType' in value) || value['dictionaryType'] === undefined) return false;
    if (!('parentId' in value) || value['parentId'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    return true;
}

export function GetDictionaryDtoFromJSON(json: any): GetDictionaryDto {
    return GetDictionaryDtoFromJSONTyped(json, false);
}

export function GetDictionaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDictionaryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'systemNumber': json['systemNumber'],
        'shortname': json['shortname'],
        'value': json['value'],
        'valueEn': json['valueEn'],
        'dictionaryTypeId': json['dictionaryTypeId'],
        'dictionaryType': GetDictionaryTypeDtoFromJSON(json['dictionaryType']),
        'parentId': json['parentId'],
        'active': json['active'],
    };
}

export function GetDictionaryDtoToJSON(value?: GetDictionaryDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'systemNumber': value['systemNumber'],
        'shortname': value['shortname'],
        'value': value['value'],
        'valueEn': value['valueEn'],
        'dictionaryTypeId': value['dictionaryTypeId'],
        'dictionaryType': GetDictionaryTypeDtoToJSON(value['dictionaryType']),
        'parentId': value['parentId'],
        'active': value['active'],
    };
}

